export function encodeQueryData(data: { [key: string]: string }) {
    const values: string[] = [];
    for (let k in data) {
        values.push(`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`);
    }
    return values.length > 0 ? `?${values.join('&')}` : '';
}
